module.exports = __webpack_public_path__ + "img/icon_jczimusel.32d3b1a1.svg";